/**
 * Thin server-function wrapper: surfaces publishable audit config (the
 * playbook checkout URL, the embedded order-form URL, and support email) to
 * the client. These are public values stored as server env vars, so they're
 * returned through RPC rather than exposed via a VITE_ prefix. Per the
 * splitting rule, this file contains ONLY the createServerFn declaration —
 * env is read inside the handler.
 */
import { createServerFn } from "@tanstack/react-start";

export interface AuditPublicConfig {
  playbookCheckoutUrl: string;
  playbookOrderFormUrl: string;
  supportEmail: string;
}

export const getAuditPublicConfig = createServerFn({ method: "GET" }).handler(
  async (): Promise<AuditPublicConfig> => {
    return {
      playbookCheckoutUrl: process.env.PLAYBOOK_CHECKOUT_URL || "",
      playbookOrderFormUrl: process.env.PLAYBOOK_ORDER_FORM_URL || "",
      supportEmail: process.env.SUPPORT_EMAIL || "",
    };
  },
);
